import styled from 'styled-components';

export const Intro = styled.p`
  max-width: 720px;
  margin: 12px 0 24px;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.65;
  text-wrap: pretty;
`;

export const ProviderSection = styled.section`
  display: grid;
  gap: 12px;
  margin: 22px 0 16px;
`;

export const ProviderActions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;

  > button {
    width: 100%;
    min-height: 50px;
  }
`;

export const AuthDivider = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 14px;
  margin: 4px 0 8px;
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.sm};

  &::before,
  &::after {
    content: '';
    height: 1px;
    background: ${(p) => p.theme.colors.gray100};
  }
`;

export const RegistrationForm = styled.form`
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px 28px;
  margin-top: 4px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 18px;
  }
`;

export const FullWidth = styled.div`
  grid-column: 1 / -1;
  min-width: 0;
`;

export const AgreementGroup = styled.fieldset`
  grid-column: 1 / -1;
  display: grid;
  gap: 4px;
  min-width: 0;
  padding-top: 14px;
  border: 0;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};
`;

export const ActionRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;

  @media (max-width: 639px) {
    flex-direction: column;
    align-items: stretch;

    > button {
      width: 100%;
    }
  }
`;

export const StatusMessage = styled.div<{ tone?: 'info' | 'error' | 'success' }>`
  margin: 18px 0 24px;
  padding: 16px 18px;
  border-left: 4px solid ${(p) => p.tone === 'error'
    ? p.theme.colors.danger
    : p.tone === 'success'
      ? p.theme.colors.secondary500
      : p.theme.colors.primary500};
  background: ${(p) => p.tone === 'error' ? '#fff2f2' : p.theme.colors.surface};
  color: ${(p) => p.theme.colors.gray500};
  line-height: 1.6;
  overflow-wrap: anywhere;
`;
